module.exports = __webpack_public_path__ + "img/web_winona_r2_32817_1.a1eb8b5f.svg";